import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Droplets, Pill, GlassWater } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <GlassWater size={28} className="text-gold-400" data-id="element-277" />,
    title: 'Restringir líquidos drásticamente',
    desc: 'Beber menos agua deshidrata tu cuerpo y concentra la orina, lo que paradójicamente puede irritar más la vejiga y aumentar la sensación de urgencia.'
  }, {
    icon: <Pill size={28} className="text-gold-400" data-id="element-278" />,
    title: 'Depender solo de suplementos genéricos',
    desc: 'Muchos productos prometen soluciones mágicas, pero ignoran los hábitos diarios y los irritantes dietéticos que realmente disparan las alertas nocturnas.'
  }, {
    icon: <Droplets size={28} className="text-gold-400" data-id="element-279" />,
    title: 'Ignorar el vaciado incompleto',
    desc: 'Si te acuestas con "residuo" en la vejiga, tu cuerpo te despertará mucho antes. No se trata solo de ir al baño, sino de cómo lo haces antes de dormir.'
  }];
  return <section className="bg-navy-950 text-cream-50 py-20 md:py-28 relative border-y border-navy-800" data-id="element-280">
      <div className="container mx-auto px-4" data-id="element-281">
        <div className="max-w-[900px] mx-auto" data-id="element-282">
          <FadeIn data-id="element-283">
            <div className="text-center mb-16" data-id="element-284">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-285">
                Por qué lo obvio no siempre funciona
              </h2>
              <p className="text-lg text-cream-100/70 max-w-2xl mx-auto" data-id="element-286">
                La mayoría de los hombres intentan soluciones rápidas que a
                menudo empeoran el problema o no abordan la raíz de la urgencia
                nocturna.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-287">
            {problems.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-288">
                <div className="bg-navy-900 rounded-2xl p-8 border border-navy-800 h-full transition-colors hover:border-gold-500/30" data-id="element-289">
                  <div className="w-14 h-14 rounded-xl bg-navy-800 flex items-center justify-center mb-6 shadow-inner" data-id="element-290">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-291">
                    {item.title}
                  </h3>
                  <p className="text-cream-100/70 leading-relaxed" data-id="element-292">
                    {item.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}